import { Component, OnInit } from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';
import { environment } from '../../environments/environment';
import * as $ from 'jquery';
import 'fullcalendar';
declare var require: any;
var moment = require('moment');

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.scss']
})
export class AdminComponent implements OnInit {
  // Auth
  isLoggedIn = false;
  token: string = '';
  admin: any = null;
  loginError: string = '';

  // Login form
  email: string = '';
  password: string = '';

  // Data
  locations: any[] = [];
  devis: any[] = [];
  tarifs: any[] = [];
  activeTab: string = 'calendar';

  // Tarif editing
  editingTarif: any = null;
  newTarif: any = { code: '', label: '', price: 0, priceTTC: 0, description: '', isActive: true, sortOrder: 0 };

  // Devis detail
  selectedDevis: any = null;

  // Calendar
  calendarInitialized = false;
  devisCalendarInitialized = false;

  private apiUrl = environment.apiUrl;

  constructor(private http: Http) {
    // Check for existing token
    const savedToken = localStorage.getItem('klix_token');
    if (savedToken) {
      this.token = savedToken;
      this.checkAuth();
    }
  }

  ngOnInit() {
  }

  // ========== AUTH ==========

  login() {
    this.loginError = '';
    const headers = new Headers({ 'Content-Type': 'application/json' });
    const options = new RequestOptions({ headers });

    this.http.post(`${this.apiUrl}/auth/login`, { email: this.email, password: this.password }, options)
      .toPromise()
      .then(response => {
        const data = response.json();
        this.token = data.token;
        this.admin = data.admin;
        this.isLoggedIn = true;
        localStorage.setItem('klix_token', this.token);
        this.loadData();
        setTimeout(() => this.initCalendar(), 200);
      })
      .catch(error => {
        console.error('Login error:', error);
        this.loginError = 'Email ou mot de passe incorrect';
      });
  }

  checkAuth() {
    const headers = new Headers({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.token}`
    });
    const options = new RequestOptions({ headers });

    this.http.get(`${this.apiUrl}/auth/me`, options)
      .toPromise()
      .then(response => {
        const data = response.json();
        this.admin = data.admin;
        this.isLoggedIn = true;
        this.loadData();
        setTimeout(() => this.initCalendar(), 200);
      })
      .catch(error => {
        console.error('Auth check failed:', error);
        this.logout();
      });
  }

  logout() {
    this.token = '';
    this.admin = null;
    this.isLoggedIn = false;
    localStorage.removeItem('klix_token');
  }

  // ========== DATA LOADING ==========

  loadData() {
    this.loadLocations();
    this.loadDevis();
    this.loadTarifs();
  }

  loadLocations() {
    this.http.get(`${this.apiUrl}/locations`)
      .toPromise()
      .then(response => {
        this.locations = response.json();
      })
      .catch(error => console.error('Load locations error:', error));
  }

  loadDevis() {
    const headers = new Headers({
      'Authorization': `Bearer ${this.token}`
    });
    const options = new RequestOptions({ headers });

    this.http.get(`${this.apiUrl}/devis`, options)
      .toPromise()
      .then(response => {
        this.devis = response.json();
      })
      .catch(error => console.error('Load devis error:', error));
  }

  loadTarifs() {
    const headers = new Headers({
      'Authorization': `Bearer ${this.token}`
    });
    const options = new RequestOptions({ headers });

    this.http.get(`${this.apiUrl}/tarifs/all`, options)
      .toPromise()
      .then(response => {
        this.tarifs = response.json();
      })
      .catch(error => console.error('Load tarifs error:', error));
  }

  // ========== TARIFS MANAGEMENT ==========

  saveTarif(tarif: any) {
    const headers = new Headers({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.token}`
    });
    const options = new RequestOptions({ headers });

    if (tarif.id) {
      // Update existing
      this.http.put(`${this.apiUrl}/tarifs/${tarif.id}`, tarif, options)
        .toPromise()
        .then(response => {
          const updated = response.json();
          const index = this.tarifs.findIndex(t => t.id === tarif.id);
          if (index !== -1) {
            this.tarifs[index] = updated;
          }
          this.editingTarif = null;
        })
        .catch(error => console.error('Update tarif error:', error));
    } else {
      // Create new
      this.http.post(`${this.apiUrl}/tarifs`, tarif, options)
        .toPromise()
        .then(response => {
          const created = response.json();
          this.tarifs.push(created);
          this.resetNewTarif();
        })
        .catch(error => console.error('Create tarif error:', error));
    }
  }

  editTarif(tarif: any) {
    this.editingTarif = { ...tarif };
  }

  cancelEditTarif() {
    this.editingTarif = null;
  }

  deleteTarif(tarif: any) {
    if (!confirm(`Voulez-vous vraiment supprimer le tarif "${tarif.label}" ?`)) return;

    const headers = new Headers({
      'Authorization': `Bearer ${this.token}`
    });
    const options = new RequestOptions({ headers });

    this.http.delete(`${this.apiUrl}/tarifs/${tarif.id}`, options)
      .toPromise()
      .then(() => {
        this.tarifs = this.tarifs.filter(t => t.id !== tarif.id);
      })
      .catch(error => console.error('Delete tarif error:', error));
  }

  toggleTarifActive(tarif: any) {
    const updated = { ...tarif, isActive: !tarif.isActive };
    this.saveTarif(updated);
  }

  resetNewTarif() {
    this.newTarif = { code: '', label: '', price: 0, priceTTC: 0, description: '', isActive: true, sortOrder: 0 };
  }

  // ========== CALENDAR ==========

  initCalendar() {
    if (this.calendarInitialized) return;

    const calEl = $('#admin-calendar');
    if (!calEl.length) return;

    this.calendarInitialized = true;
    const self = this;
    const events: any[] = this.locations.map(loc => ({
      id: loc.id,
      title: '',
      start: moment(loc.date).format('YYYY-MM-DD'),
      end: moment(loc.date).format('YYYY-MM-DD'),
      rendering: 'background',
      color: '#dc3545'
    }));

    $('#admin-calendar').fullCalendar({
      locale: 'fr',
      defaultView: 'month',
      editable: false,
      eventLimit: true,
      aspectRatio: 1.5,
      events: events,
      dayClick: (date, jsEvent, view) => {
        self.toggleDate(date);
      },
      hiddenDays: [],
      weekNumbers: false,
      allDaySlot: false,
    });
  }

  toggleDate(date: any) {
    const dateStr = date.format('YYYY-MM-DD');
    const existing = this.locations.find(loc =>
      moment(loc.date).format('YYYY-MM-DD') === dateStr
    );

    if (existing) {
      this.deleteLocation(existing.id, dateStr);
    } else {
      this.addLocation(date);
    }
  }

  addLocation(date: any) {
    const headers = new Headers({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.token}`
    });
    const options = new RequestOptions({ headers });

    const jours = ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'];
    const data = {
      date: date.format('YYYY-MM-DD'),
      jour: jours[date.day()]
    };

    this.http.post(`${this.apiUrl}/locations`, data, options)
      .toPromise()
      .then(response => {
        const loc = response.json();
        this.locations.push(loc);
        this.refreshCalendar();
      })
      .catch(error => console.error('Add location error:', error));
  }

  deleteLocation(id: string, dateStr: string) {
    const headers = new Headers({
      'Authorization': `Bearer ${this.token}`
    });
    const options = new RequestOptions({ headers });

    this.http.delete(`${this.apiUrl}/locations/${id}`, options)
      .toPromise()
      .then(() => {
        this.locations = this.locations.filter(loc => loc.id !== id);
        this.refreshCalendar();
      })
      .catch(error => console.error('Delete location error:', error));
  }

  refreshCalendar() {
    const events: any[] = this.locations.map(loc => ({
      id: loc.id,
      title: '',
      start: moment(loc.date).format('YYYY-MM-DD'),
      end: moment(loc.date).format('YYYY-MM-DD'),
      rendering: 'background',
      color: '#dc3545'
    }));

    const cal: any = $('#admin-calendar');
    cal.fullCalendar('removeEvents');
    cal.fullCalendar('addEventSource', events);
  }

  // ========== DEVIS MANAGEMENT ==========

  selectDevis(d: any) {
    if (this.selectedDevis && this.selectedDevis.id === d.id) {
      this.selectedDevis = null;
      this.devisCalendarInitialized = false;
      return;
    }
    this.selectedDevis = d;
    this.devisCalendarInitialized = false;
    setTimeout(() => this.initDevisCalendar(), 200);
  }

  initDevisCalendar() {
    if (this.devisCalendarInitialized || !this.selectedDevis) return;

    const calEl = $('#devis-detail-calendar');
    if (!calEl.length) return;

    // Destroy previous instance if any
    calEl.fullCalendar('destroy');
    this.devisCalendarInitialized = true;

    const events: any[] = this.selectedDevis.dates.map((d: any) => ({
      title: this.getSelLabel(d.sel),
      start: moment(d.date).format('YYYY-MM-DD'),
      allDay: true,
      color: '#007bff'
    }));

    // Find earliest date to set default view
    const firstDate = this.selectedDevis.dates.length > 0
      ? moment(this.selectedDevis.dates[0].date).format('YYYY-MM-DD')
      : moment().format('YYYY-MM-DD');

    calEl.fullCalendar({
      locale: 'fr',
      defaultView: 'month',
      defaultDate: firstDate,
      editable: false,
      eventLimit: true,
      aspectRatio: 1.35,
      header: {
        left: 'prev,next',
        center: 'title',
        right: ''
      },
      events: events,
      hiddenDays: [],
      weekNumbers: false,
      allDaySlot: false,
    });
  }

  getSelLabel(sel: string): string {
    if (!sel) return '';
    if (sel.startsWith('heure:')) {
      const times = sel.replace('heure:', '');
      return 'À l\'heure (' + times + ')';
    }
    switch (sel) {
      case 'journee': return 'Journée (8h30-18h)';
      case 'matin': return 'Demi-journée Matin (8h30-13h)';
      case 'apres-midi': return 'Demi-journée Après-midi (13h30-18h)';
      case 'demi-journee': return 'Demi-journée';
      default: return sel;
    }
  }

  updateDevisStatus(devis: any, status: string) {
    const headers = new Headers({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.token}`
    });
    const options = new RequestOptions({ headers });

    this.http.patch(`${this.apiUrl}/devis/${devis.id}/status`, { status }, options)
      .toPromise()
      .then(response => {
        const updated = response.json();
        const index = this.devis.findIndex(d => d.id === devis.id);
        if (index !== -1) {
          this.devis[index] = updated;
        }
      })
      .catch(error => console.error('Update devis status error:', error));
  }

  deleteDevis(devis: any) {
    if (!confirm('Voulez-vous vraiment supprimer ce devis ?')) return;

    const headers = new Headers({
      'Authorization': `Bearer ${this.token}`
    });
    const options = new RequestOptions({ headers });

    this.http.delete(`${this.apiUrl}/devis/${devis.id}`, options)
      .toPromise()
      .then(() => {
        this.devis = this.devis.filter(d => d.id !== devis.id);
      })
      .catch(error => console.error('Delete devis error:', error));
  }

  formatDate(dateStr: string): string {
    return moment(dateStr).format('DD/MM/YYYY');
  }

  getStatusLabel(status: string): string {
    switch (status) {
      case 'pending': return 'En attente';
      case 'confirmed': return 'Confirmé';
      case 'cancelled': return 'Annulé';
      default: return status;
    }
  }

  getStatusClass(status: string): string {
    switch (status) {
      case 'pending': return 'badge-warning';
      case 'confirmed': return 'badge-success';
      case 'cancelled': return 'badge-danger';
      default: return 'badge-secondary';
    }
  }
}
